import React from "react";
import { Typography, Grid, Button } from "@mui/material";
import "../page/about";
import Navbar from "../navbar";
import Footer from "../Footer";
import Covid19 from "../../asset/covid.png";
import Veiw from "../../asset/veiw.jpg";
import Road from "../../asset/road.jpg";
import Inner from "../../asset/inner.jpg";
import Front from "../../asset/front.jpg";
import "../Header/header.css";

const data = [
  {
    img: Veiw,
  },
  {
    img: Road,
  },
  {
    img: Inner,
  },
  {
    img: Front,
  },
];

const Building = () => {
  return (
    <>
      <Navbar />
      <Grid container>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ padding: "50px 0", background: "#2F70FE", textAlign: "center" }}
        >
          <Typography className="text">Buildings</Typography>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "space-around",
          margin: "20px 0",
        }}
      >
        {data.map((s) => (
          <Grid item xs={10} md={5}>
            <img
              style={{
                width: "100%",
                height: "400px",
                marginTop: "10px",
                borderRadius: "50px",
              }}
              src={s.img}
            />
          </Grid>
        ))}
      </Grid>

      {/* <Footer /> */}
    </>
  );
};
export default Building;
